import breakpoints from "../breakpoints";

const bar = document.querySelector('.js-BenefitsBar');

let isInitialised = false;
let children;
let speed;
let interval = null;
let currentIndex = 0;

function initialise() {
  children = Array.from(bar.children);
  speed = Number(bar.dataset.speed) || 2500;

  interval = setInterval(() => {  
    setActive(currentIndex);

    if(currentIndex >= 0 && currentIndex < children.length - 1) {
      currentIndex++;
    } else {
      currentIndex = 0;
    }
  }, speed);

  setActive(currentIndex);

  isInitialised = true;
}

function destroy() {
  if(!isInitialised) return;

  clearInterval(interval);

  children.forEach(child => {
    child.classList.remove('is-active');
  });
}

function setActive(index) {
  children[index].classList.add('is-active');

  if(index === 0) {
    children[children.length - 1].classList.remove('is-active');
  }

  if(index > 0) {
    children[index - 1].classList.remove('is-active');
  }  
}

function handleMediaQueryChange(mq) {
  if( mq.matches ) {
    initialise();
  } else {
    destroy();
  }
}

if( bar ) {
  const mq = window.matchMedia(`(max-width: ${breakpoints.large - 1}px)`);
  mq.addEventListener('change', handleMediaQueryChange );
  handleMediaQueryChange(mq);
}

